import styled from 'styled-components';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';
import { COLOR_WHITE } from '../../../assets/styles/colors';

const DocsModalContent = styled.div`
  box-sizing: border-box;
  width: 900px;
  max-width: 98vw;
  height: 85vh;
  max-height: 85vh;
  background: ${COLOR_WHITE};
  border-radius: 16px;
  padding: 20px 32px 24px 32px;
  box-shadow: 0 2px 24px rgba(0,0,0,0.10);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  @media (max-width: ${BP_MOBILE_MAX}px) {
    width: 95vw;
    max-width: 95vw;
    min-width: 0;
    height: 90vh;
    max-height: 90vh;
    min-height: 0;
    border-radius: 12px;
    padding: 16px 8px 12px 8px;
    box-shadow: 0 2px 24px rgba(0,0,0,0.10);
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: hidden;
    z-index: 1000;
  }

  .docs-modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 40px;
    margin-bottom: 16px;
    box-sizing: border-box;
    position: relative;
    flex-shrink: 0;

    @media (max-width: ${BP_MOBILE_MAX}px) {
      min-height: 36px;
      margin-bottom: 12px;
    }
  }

  .docs-modal-title {
    flex: 1;
    font-size: 1.125rem;
    font-weight: 600;
    text-align: center;
    word-break: break-word;
    box-sizing: border-box;
    margin: 0;
    padding: 0 60px;
    line-height: 1.4;
    overflow-x: hidden;
    color: #333;

    @media (max-width: ${BP_MOBILE_MAX}px) {
      font-size: 1rem;
      padding: 0 50px;
    }
  }

  .close-button {
    position: absolute;
    top: 0;
    right: 0;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    z-index: 2;
    width: 48px;
    height: 48px;
    font-size: 2rem;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .docs-modal-close {
    width: 48px;
    height: 48px;
    background: transparent;
    border: none;
    font-size: 2rem;
    color: #333;
    z-index: 1100;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
  }

  .docs-modal-content-area {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: stretch;
    min-height: 0;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    margin-bottom: 16px;
  }

  .docs-modal-read-notice {
    text-align: center;
    padding: 6px 12px;
    margin: 0 0 8px 0;
    background: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 4px;
    color: #856404;
    font-size: 13px;
    font-weight: 500;
    flex-shrink: 0;
    min-height: 30px;
    line-height: 1.3;
    transition: opacity 0.2s ease, visibility 0.2s ease;

    &.hidden {
      visibility: hidden;
      opacity: 0;
    }

    @media (max-width: ${BP_MOBILE_MAX}px) {
      font-size: 12px;
      padding: 5px 10px;
      min-height: 26px;
    }
  }
  
  .docs-modal-pdf-viewer {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    height: 100%;
    border: 1px solid #eee;
    border-radius: 4px;
    background: #f8f8f8;
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
  }
  
  .docs-modal-iframe {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    height: 100%;
    min-height: 40svh;
    border: 1px solid #eee;
    border-radius: 0;
    background: #f8f8f8;
    margin-bottom: 16px;
    flex: 1 1 auto;
    overflow-x: hidden;
  }
  .docs-modal-actions {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 0;
    box-sizing: border-box;
    padding: 12px 8px 4px 8px;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    flex-shrink: 0;
    border-top: 1px solid #eee;
    background: ${COLOR_WHITE};
  }
  
  .docs-modal-pagination {
    text-align: center;
    font-size: 13px;
    color: #666;
    padding: 4px 0 0 0;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    flex-shrink: 0;
  }
`;

export default DocsModalContent;
